<div class="app-shell">
  <!-- MAIN WRAPPER (PLEINE LARGEUR) -->
  <div class="main-wrapper">
    <!-- EN-TETE SUPERIEUR -->
    <header class="top-header">
      <div class="header-left">
        <!-- Logo et Identité Domino -->
        <a routerLink="/" class="brand-header" title="Aller à la page d'accueil">
          <img src="assets/logo_domino.png" alt="Domino" class="brand-logo" />
          <h1 class="brand-title">Domino</h1>
        </a>

        <!-- Bouton Retour à l'accueil (visible sur toutes les pages sauf l'accueil) -->
        @if (!isHomePage) {
          <div class="header-divider"></div>
          <a routerLink="/" class="btn-back-home" title="Retourner à l'accueil de Domino">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            <span>Retour à l'accueil</span>
          </a>
        }
      </div>

      <!-- Profil Utilisateur & Déconnexion -->
      @if (user$ | async; as user) {
        <div class="user-profile">
          <span class="user-avatar">{{ getUserDisplayName(user).charAt(0).toUpperCase() }}</span>
          <div class="user-info">
            <span class="user-name">{{ getUserDisplayName(user) }}</span>
            <span class="user-role">{{ getUserProfile(user) }}</span>
          </div>
          <button class="btn btn-outline btn-logout" (click)="logout()">Déconnexion</button>
        </div>
      }
    </header>

    <!-- ZONE DE CONTENU PRINCIPALE -->
    <main class="content-area">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

